var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 8.40015C7.2002 8.95243 7.64791 9.40015 8.2002 9.40015C8.75248 9.40015 9.2002 8.95243 9.2002 8.40015C9.2002 7.84786 8.75248 7.40015 8.2002 7.40015C7.64791 7.40015 7.2002 7.84786 7.2002 8.40015Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 12.8C7.2002 13.3523 7.64791 13.8 8.2002 13.8C8.75248 13.8 9.2002 13.3523 9.2002 12.8C9.2002 12.2478 8.75248 11.8 8.2002 11.8C7.64791 11.8 7.2002 12.2478 7.2002 12.8Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2002 4C7.2002 4.55228 7.64791 5 8.2002 5C8.75248 5 9.2002 4.55228 9.2002 4C9.2002 3.44772 8.75248 3 8.2002 3C7.64791 3 7.2002 3.44772 7.2002 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.a1c5948f43c97f667c4bd08091ce846f.svg";
export { ForwardRef as ReactComponent };